// extracted by mini-css-extract-plugin
export default {"iconContainer":"twV6if-3FZn6Z5NnZMEjNg==","subtitle":"KOoRZZUDhc8WcB9i4UZVjg==","lottieIllustration":"F8w9ua5ToDvtgQKufPFZbQ=="};